import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Card.module.scss";

const Card = ({ variant, name, amount, duration, features }) => {
  const navigate = useNavigate();
  const variantClass =
    variant === "primary" ? styles.primary : styles.secondary;

  const handleClick = () => {
    const planName = name.toUpperCase();
    localStorage.setItem("planName", planName);
    localStorage.setItem("planAmount", amount);
    navigate("/order-summary");
  };

  return (
    <div className={`${styles.container} ${variantClass}`}>
      <h3>{name}</h3>
      <h1>${amount}</h1>
      <p>per {duration}</p>
      <button onClick={handleClick}>Buy now</button>
      <hr />
      <ul>
        {features.map((i) => (
          <li>{i}</li>
        ))}
      </ul>
    </div>
  );
};

export default Card;
